export const checkoutPageStyles = `
  .pondstat-checkout-page {
    min-height: calc(100vh - 60px);
    background: linear-gradient(160deg, #f0f4f8 0%, #e8f4f3 50%, #f8f9fa 100%);
    padding: 32px 16px 48px;
  }
  .pondstat-checkout-page__container {
    max-width: 520px;
    margin: 0 auto;
  }
  .pondstat-checkout-page__back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 20px;
    padding: 8px 14px;
    border: none;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.8);
    color: #4b5563;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
  }
  .pondstat-checkout-page__back:hover {
    background: #fff;
    color: #2b7a78;
  }
  .pondstat-checkout-summary {
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 8px 30px rgba(15, 23, 42, 0.08);
    border: 1px solid #e8ecef;
    overflow: hidden;
  }
  .pondstat-checkout-summary__body {
    padding: 28px 24px;
  }
  .pondstat-checkout-summary__badge {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #2b7a78;
    background: rgba(78, 205, 196, 0.12);
    padding: 4px 10px;
    border-radius: 20px;
    margin-bottom: 12px;
  }

  /* Registration wizard */
  .pondstat-register-wizard {
    max-width: 640px;
    margin: 0 auto;
  }
  .pondstat-register-wizard__header {
    text-align: center;
    margin-bottom: 28px;
  }
  .pondstat-register-wizard__logo {
    font-size: 2.25rem;
    font-weight: 800;
    letter-spacing: -0.02em;
    margin-bottom: 10px;
  }
  .pondstat-register-wizard__title {
    font-size: 1.625rem;
    font-weight: 700;
    color: #111827 !important;
    margin: 0 0 8px;
  }
  .pondstat-register-wizard__subtitle {
    color: #6b7280 !important;
    font-size: 15px;
    margin: 0;
    line-height: 1.5;
  }
  .pondstat-register-steps {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 0;
    margin-bottom: 28px;
    padding: 0 8px;
  }
  .pondstat-register-step {
    flex: 1;
    max-width: 140px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    text-align: center;
  }
  .pondstat-register-step:not(:last-child)::after {
    content: "";
    position: absolute;
    top: 18px;
    left: calc(50% + 22px);
    width: calc(100% - 44px);
    height: 2px;
    background: #e5e7eb;
    z-index: 0;
  }
  .pondstat-register-step--done:not(:last-child)::after {
    background: #4ECDC4;
  }
  .pondstat-register-step__circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    border: 2px solid #e5e7eb;
    background: #fff;
    color: #9ca3af;
    position: relative;
    z-index: 1;
    transition: all 0.2s ease;
  }
  .pondstat-register-step--active .pondstat-register-step__circle {
    border-color: #4ECDC4;
    background: linear-gradient(135deg, #4ECDC4 0%, #3bb5ad 100%);
    color: #fff;
    box-shadow: 0 4px 14px rgba(78, 205, 196, 0.4);
  }
  .pondstat-register-step--done .pondstat-register-step__circle {
    border-color: #4ECDC4;
    background: #fff;
    color: #2b7a78;
  }
  .pondstat-register-step__label {
    margin-top: 8px;
    font-size: 13px;
    font-weight: 600;
    color: #9ca3af;
  }
  .pondstat-register-step--active .pondstat-register-step__label,
  .pondstat-register-step--done .pondstat-register-step__label {
    color: #374151;
  }
  .pondstat-register-step__hint {
    font-size: 11px;
    color: #9ca3af;
    margin-top: 2px;
  }
  .pondstat-register-card {
    background: #fff;
    border-radius: 20px;
    padding: 28px 24px;
    box-shadow: 0 8px 30px rgba(15, 23, 42, 0.08);
    border: 1px solid #e8ecef;
    margin-bottom: 16px;
  }
  .pondstat-register-card__heading {
    font-size: 17px;
    font-weight: 700;
    color: #111827 !important;
    margin: 0 0 6px;
  }
  .pondstat-register-card__desc {
    font-size: 14px;
    color: #6b7280 !important;
    margin: 0 0 22px;
  }
  .pondstat-register-field {
    margin-bottom: 18px;
  }
  .pondstat-register-field label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
  }
  .pondstat-register-field input {
    width: 100%;
    padding: 13px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    font-size: 16px;
    outline: none;
    background: #fff;
    color: #111827;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }
  .pondstat-register-field input:focus {
    border-color: #4ECDC4;
    box-shadow: 0 0 0 4px rgba(78, 205, 196, 0.12);
  }
  .pondstat-register-field input::placeholder {
    color: #9ca3af;
  }
  .pondstat-register-field-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
  }
  @media (max-width: 576px) {
    .pondstat-register-field-row {
      grid-template-columns: 1fr;
    }
    .pondstat-register-wizard__logo {
      font-size: 1.85rem;
    }
    .pondstat-register-wizard__title {
      font-size: 1.35rem;
    }
    .pondstat-register-step__hint {
      display: none;
    }
  }
  .pondstat-register-plan-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .pondstat-register-plan-card {
    display: block;
    width: 100%;
    text-align: left;
    border: 2px solid #e5e7eb;
    border-radius: 16px;
    padding: 18px 20px;
    background: #fff;
    color: #374151 !important;
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  }
  .pondstat-register-plan-card:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
  }
  .pondstat-register-plan-card--selected {
    border-color: #4ECDC4;
    background: linear-gradient(180deg, rgba(78, 205, 196, 0.06) 0%, #fff 100%);
    box-shadow: 0 4px 20px rgba(78, 205, 196, 0.15);
  }
  .pondstat-register-plan-card__top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
  }
  .pondstat-register-plan-card__name {
    font-size: 16px;
    font-weight: 700;
    color: #111827 !important;
    margin: 0;
  }
  .pondstat-register-plan-card__price {
    font-size: 20px;
    font-weight: 800;
    color: #2b7a78;
    white-space: nowrap;
  }
  .pondstat-register-plan-card__price small {
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
  }
  .pondstat-register-plan-card__features {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .pondstat-register-plan-card__features li {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #4b5563 !important;
  }
  .pondstat-register-plan-card__radio {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #d1d5db;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
  }
  .pondstat-register-plan-card--selected .pondstat-register-plan-card__radio {
    border-color: #4ECDC4;
    background: #4ECDC4;
  }
  .pondstat-register-plan-card--selected .pondstat-register-plan-card__radio::after {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fff;
  }
  .pondstat-register-plan-card-wrap {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  .pondstat-register-plan-card-wrap .pondstat-register-plan-card {
    border-radius: 16px;
  }
  .pondstat-register-plan-card-wrap--selected .pondstat-register-plan-card {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-color: rgba(78, 205, 196, 0.35);
  }
  .pondstat-register-plan-card__desc {
    font-size: 13px;
    color: #6b7280 !important;
    margin: 0 0 10px;
    line-height: 1.45;
  }
  .pondstat-register-plan-card__pond-note {
    font-size: 13px;
    color: #6b7280 !important;
    margin: 8px 0 0;
  }
  .pondstat-register-plan-card__extra-price {
    font-size: 12px;
    color: #6b7280;
    margin-top: 2px;
  }
  .pondstat-register-plan-card__pond-picker {
    border: 2px solid #4ECDC4;
    border-top: none;
    border-radius: 0 0 16px 16px;
    padding: 16px 20px;
    background: linear-gradient(180deg, rgba(78, 205, 196, 0.06) 0%, #fff 100%);
  }
  .pondstat-register-plan-card__pond-picker label {
    font-size: 13px;
    font-weight: 600;
    color: #374151 !important;
    margin-bottom: 8px;
    display: block;
  }
  .pondstat-register-plan-card__pond-picker input {
    max-width: 120px;
    padding: 10px 14px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    font-size: 16px;
  }
  .pondstat-register-plan-card__pond-picker-hint {
    font-size: 12px;
    color: #6b7280 !important;
    margin: 8px 0 0;
  }
  .pondstat-register-plan-card__pond-total {
    font-size: 13px;
    color: #374151;
    margin-top: 8px;
  }
  .pondstat-register-ponds-row {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #f3f4f6;
  }
  .pondstat-register-ponds-row label {
    font-size: 13px;
    font-weight: 600;
    color: #374151 !important;
    margin-bottom: 8px;
    display: block;
  }
  .pondstat-register-ponds-row input {
    max-width: 120px;
    padding: 10px 14px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    font-size: 16px;
  }
  .pondstat-register-order-strip {
    background: #f8fafc;
    border: 1px solid #e8ecef;
    border-radius: 14px;
    padding: 16px 18px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .pondstat-register-order-strip__plan {
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    margin: 0 0 2px;
  }
  .pondstat-register-order-strip__meta {
    font-size: 12px;
    color: #6b7280;
    margin: 0;
  }
  .pondstat-register-order-strip__total {
    font-size: 22px;
    font-weight: 800;
    color: #2b7a78;
    white-space: nowrap;
  }
  .pondstat-register-order-strip__total small {
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
  }
  .pondstat-register-nav {
    display: flex;
    gap: 12px;
    margin-top: 8px;
  }
  .pondstat-register-nav__back {
    flex: 0 0 auto;
    padding: 14px 20px;
    border: 2px solid #e5e7eb;
    border-radius: 14px;
    background: #fff;
    color: #374151;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease;
  }
  .pondstat-register-nav__back:hover {
    border-color: #cbd5e1;
    background: #f9fafb;
  }
  .pondstat-register-nav__next {
    flex: 1;
    padding: 14px 20px;
    border: none;
    border-radius: 14px;
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, #4ECDC4 0%, #3bb5ad 100%);
    box-shadow: 0 6px 20px rgba(78, 205, 196, 0.35);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  }
  .pondstat-register-nav__next:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 8px 24px rgba(78, 205, 196, 0.45);
  }
  .pondstat-register-nav__next:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
  .pondstat-register-footer {
    text-align: center;
    margin-top: 24px;
    font-size: 14px;
    color: #6b7280;
  }
  .pondstat-register-footer a {
    color: #2b7a78;
    font-weight: 600;
    text-decoration: none;
  }
  .pondstat-register-footer a:hover {
    text-decoration: underline;
  }
  .pondstat-register-copyright {
    text-align: center;
    margin-top: 20px;
    color: #9ca3af;
    font-size: 12px;
  }
  .pondstat-stripe-section.mt-0 {
    margin-top: 0 !important;
  }
`;
